import { render, staticRenderFns } from "./UpsModal.vue?vue&type=template&id=0b16c3ae&"
import script from "./UpsModal.vue?vue&type=script&lang=js&"
export * from "./UpsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpsModal.vue"
export default component.exports